import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import AbcIcon from "@mui/icons-material/Abc";
import BrushIcon from "@mui/icons-material/Brush";
import PersonIcon from "@mui/icons-material/Person";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import EditIcon from "@mui/icons-material/Edit";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CheckIcon from "@mui/icons-material/Check";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import "../styles/Sidebar.css";
import { getAvailableVoices, saveVoicePreference } from "../utils/speech";

const ENGLISH_LISTS = [
  { value: "K2_Week6.txt", label: "K2 Spelling Week 6" },
  { value: "K2_Week7.txt", label: "K2 Spelling Week 7" },
  { value: "K2_Week8.txt", label: "K2 Spelling Week 8" },
  { value: "K2_Week9.txt", label: "K2 Spelling Week 9" },
  { value: "K2_24Mar.txt", label: "K2 Spelling 24 Mar" },
  { value: "K2_01Apr.txt", label: "K2 Spelling 01 Apr" },
  { value: "K2_07Apr.txt", label: "K2 Spelling 07 Apr" },
  { value: "K2_14Apr.txt", label: "K2 Spelling 14 Apr" },
  { value: "K2_21Apr.txt", label: "K2 Spelling 21 Apr" },
  { value: "K2_28Apr.txt", label: "K2 Spelling 28 Apr" },
  { value: "K2_05May.txt", label: "K2 Spelling 05 May" },
  { value: "K2_12May.txt", label: "K2 Spelling 12 May" },
  { value: "K2_19May.txt", label: "K2 Spelling 19 May" },
  { value: "K2_26May.txt", label: "K2 Spelling 26 May" },
  { value: "K2_07Jul.txt", label: "K2 Spelling 07 Jul" },
  { value: "K2_14Jul.txt", label: "K2 Spelling 14 Jul" },
  { value: "K2_20Jul.txt", label: "K2 Spelling 20 Jul" },
  { value: "K2_28Jul.txt", label: "K2 Spelling 28 Jul" },
  { value: "K2_04Aug.txt", label: "K2 Spelling 04 Aug" },
  { value: "K2_11Aug.txt", label: "K2 Spelling 11 Aug" },
  { value: "K2_18Aug.txt", label: "K2 Spelling 18 Aug" },
  { value: "K2_25Aug.txt", label: "K2 Spelling 25 Aug" },
  { value: "K2_01Sep.txt", label: "K2 Spelling 01 Sep" },
  { value: "PSLE_Spelling_A.txt", label: "PSLE Spelling A" },
  { value: "PSLE_Spelling_B.txt", label: "PSLE Spelling B" },
  { value: "PSLE_Spelling_C.txt", label: "PSLE Spelling C" },
  { value: "PSLE_Spelling_D.txt", label: "PSLE Spelling D" },
  { value: "PSLE_Spelling_E.txt", label: "PSLE Spelling E" },
  { value: "PSLE_Spelling_F.txt", label: "PSLE Spelling F" },
  { value: "PSLE_Spelling_G.txt", label: "PSLE Spelling G" },
  { value: "PSLE_Spelling_H.txt", label: "PSLE Spelling H" },
  { value: "PSLE_Spelling_I.txt", label: "PSLE Spelling I" },
  { value: "PSLE_Spelling_J.txt", label: "PSLE Spelling J" },
  { value: "PSLE_Spelling_K.txt", label: "PSLE Spelling K" },
  { value: "PSLE_Spelling_L.txt", label: "PSLE Spelling L" },
  { value: "PSLE_Spelling_M.txt", label: "PSLE Spelling M" },
  { value: "PSLE_Spelling_N.txt", label: "PSLE Spelling N" },
  { value: "PSLE_Spelling_O.txt", label: "PSLE Spelling O" },
  { value: "PSLE_Spelling_P.txt", label: "PSLE Spelling P" },
  { value: "PSLE_Spelling_Q.txt", label: "PSLE Spelling Q" },
  { value: "PSLE_Spelling_R.txt", label: "PSLE Spelling R" },
  { value: "PSLE_Spelling_S.txt", label: "PSLE Spelling S" },
  { value: "PSLE_Spelling_T.txt", label: "PSLE Spelling T" },
  { value: "PSLE_Spelling_U.txt", label: "PSLE Spelling U" },
  { value: "PSLE_Spelling_V.txt", label: "PSLE Spelling V" },
  { value: "PSLE_Spelling_W.txt", label: "PSLE Spelling W" },
  { value: "PSLE_Spelling_Y.txt", label: "PSLE Spelling Y" },
];

const CHINESE_LISTS = [
  { value: "Chinese_HSK1_Basic.txt", label: "HSK1 Basic Characters" },
  { value: "Chinese_HSK1_Family.txt", label: "HSK1 Family & People" },
  { value: "K2_Chinese_0402.txt", label: "K2 Chinese 0402" },
  { value: "K2_Chinese_0409.txt", label: "K2 Chinese 0409" },
  { value: "K2_Chinese_0416.txt", label: "K2 Chinese 0416" },
  { value: "K2_Chinese_0423.txt", label: "K2 Chinese 0423" },
  { value: "K2_Chinese_0430.txt", label: "K2 Chinese 0430" },
  { value: "K2_Chinese_0507.txt", label: "K2 Chinese 0507" },
  { value: "K2_Chinese_0514.txt", label: "K2 Chinese 0514" },
  { value: "K2_Chinese_0521.txt", label: "K2 Chinese 0521" },
  { value: "K2_Chinese_09Jul.txt", label: "K2 Chinese 09 Jul" },
  { value: "K2_Chinese_16Jul.txt", label: "K2 Chinese 16 Jul" },
  { value: "K2_Chinese_23Jul.txt", label: "K2 Chinese 23 Jul" },
  { value: "K2_Chinese_30Jul.txt", label: "K2 Chinese 30 Jul" },
  { value: "K2_Chinese_6Aug.txt", label: "K2 Chinese 6 Aug" },
  { value: "K2_Chinese_13Aug.txt", label: "K2 Chinese 13 Aug" },
  { value: "K2_Chinese_20Aug.txt", label: "K2 Chinese 20 Aug" },
  { value: "K2_Chinese_27Aug.txt", label: "K2 Chinese 27 Aug" },
  { value: "K2_Chinese_Week7.txt", label: "K2 Chinese Week 7" },
  { value: "K2_Chinese_Week8.txt", label: "K2 Chinese Week 8" },
  { value: "K2_Chinese_Week9.txt", label: "K2 Chinese Week 9" },
];

export default function Sidebar({
  isOpen,
  onClose,
  userName,
  practiceType,
  selectedList,
  fileUploaded,
  activeView,
  onChangeName,
  onChangePracticeType,
  onLoadEnglishList,
  onLoadChineseList,
  onFileUpload,
  onChineseFileUpload,
  onTextInput,
  onChineseTextInput,
  onNavigate,
  onHome,
}) {
  const [editingName, setEditingName] = useState(false);
  const [nameVal, setNameVal] = useState(userName);
  const [availableVoices, setAvailableVoices] = useState([]);
  const [selectedVoiceName, setSelectedVoiceName] = useState("");

  useEffect(() => {
    if (!editingName) setNameVal(userName);
  }, [userName, editingName]);

  useEffect(() => {
    const lang = practiceType === "chinese" ? "zh" : "en";
    const lsKey = lang === "zh" ? "spellingApp_voice_zh" : "spellingApp_voice_en";
    const loadVoices = () => {
      const voices = getAvailableVoices(lang);
      setAvailableVoices(voices);
      const saved = localStorage.getItem(lsKey);
      if (saved && voices.find(v => v.name === saved)) {
        setSelectedVoiceName(saved);
      } else if (voices.length > 0) {
        setSelectedVoiceName(voices[0].name);
      } else {
        setSelectedVoiceName("");
      }
    };
    loadVoices();
    window.speechSynthesis.onvoiceschanged = loadVoices;
    return () => { window.speechSynthesis.onvoiceschanged = null; };
  }, [practiceType]);

  const handleVoiceChange = (e) => {
    const name = e.target.value;
    setSelectedVoiceName(name);
    const lang = practiceType === "chinese" ? "zh" : "en";
    saveVoicePreference(lang, name);
  };

  const saveName = () => {
    if (nameVal.trim().length >= 2) onChangeName(nameVal.trim());
    setEditingName(false);
  };

  const nav = (view) => {
    onNavigate(view);
    onClose();
  };

  const handleLangSwitch = (type) => {
    if (type !== practiceType) onChangePracticeType(type);
    onClose();
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`sidebar${isOpen ? " open" : ""}`} aria-hidden={!isOpen}>

        <div className="sidebar-header">
          <span className="sidebar-title">Menu</span>
          <button className="sidebar-close" onClick={onClose} aria-label="Close menu">
            <CloseIcon />
          </button>
        </div>

        <div className="sidebar-body">

          {/* Name */}
          <div className="sidebar-section">
            <div className="sidebar-label">
              <PersonIcon className="icon-sm" /> Name
            </div>
            {editingName ? (
              <div className="sidebar-name-row">
                <input
                  className="sidebar-name-input"
                  value={nameVal}
                  onChange={e => setNameVal(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && saveName()}
                  autoFocus
                  maxLength={20}
                  placeholder="Your name..."
                />
                <button className="sidebar-save-btn" onClick={saveName}>
                  <CheckIcon />
                </button>
              </div>
            ) : (
              <button className="sidebar-name-display" onClick={() => setEditingName(true)}>
                <span>{userName || "Tap to set name"}</span>
                <EditIcon className="icon-sm" />
              </button>
            )}
          </div>

          {/* Language toggle */}
          <div className="sidebar-section">
            <div className="sidebar-label">Practice Type</div>
            <div className="sidebar-lang-row">
              <button
                className={`sidebar-lang-btn${practiceType === "english" ? " active" : ""}`}
                onClick={() => handleLangSwitch("english")}
              >
                <AbcIcon className="icon-sm" />
                <span>English</span>
              </button>
              <button
                className={`sidebar-lang-btn${practiceType === "chinese" ? " active" : ""}`}
                onClick={() => handleLangSwitch("chinese")}
              >
                <BrushIcon className="icon-sm" />
                <span>中文</span>
              </button>
            </div>
          </div>

          {/* Voice picker */}
          {practiceType && availableVoices.length > 0 && (
            <div className="sidebar-section">
              <div className="sidebar-label">
                <RecordVoiceOverIcon className="icon-sm" /> Voice
              </div>
              <select
                className="sidebar-select"
                value={selectedVoiceName}
                onChange={handleVoiceChange}
              >
                {availableVoices.map(v => (
                  <option key={v.name} value={v.name}>{v.name} ({v.lang})</option>
                ))}
              </select>
            </div>
          )}

          {/* List selection */}
          {practiceType && (
            <div className="sidebar-section">
              <div className="sidebar-label">Word List</div>
              {practiceType === "english" ? (
                <select
                  className="sidebar-select"
                  value={selectedList || ""}
                  onChange={e => {
                    if (e.target.value) { onLoadEnglishList(e.target.value); onClose(); }
                  }}
                >
                  <option value="" disabled>Choose a list...</option>
                  {ENGLISH_LISTS.map(l => (
                    <option key={l.value} value={l.value}>{l.label}</option>
                  ))}
                </select>
              ) : (
                <select
                  className="sidebar-select"
                  value={selectedList || ""}
                  onChange={e => {
                    if (e.target.value) { onLoadChineseList(e.target.value); onClose(); }
                  }}
                >
                  <option value="" disabled>Choose a list...</option>
                  {CHINESE_LISTS.map(l => (
                    <option key={l.value} value={l.value}>{l.label}</option>
                  ))}
                </select>
              )}
              <div className="sidebar-list-actions">
                <button
                  className="sidebar-action-btn"
                  onClick={() => {
                    practiceType === "english" ? onTextInput() : onChineseTextInput();
                    onClose();
                  }}
                >
                  <EditIcon className="icon-sm" /> Type Words
                </button>
                <label className="sidebar-action-btn">
                  <AttachFileIcon className="icon-sm" /> Upload
                  <input
                    type="file"
                    accept=".txt"
                    onChange={e => {
                      practiceType === "english" ? onFileUpload(e) : onChineseFileUpload(e);
                      onClose();
                    }}
                    style={{ display: "none" }}
                  />
                </label>
              </div>
            </div>
          )}

          {/* More activities (only when list is loaded) */}
          {fileUploaded && practiceType === "chinese" && (
            <div className="sidebar-section">
              <div className="sidebar-label">More Activities</div>
              <button
                className={`sidebar-nav-item${activeView === "chinese-pinyin" ? " active" : ""}`}
                onClick={() => nav("chinese-pinyin")}
              >
                <KeyboardIcon className="icon-sm" /> Pinyin
              </button>
              <button
                className={`sidebar-nav-item${activeView === "chinese-writing" ? " active" : ""}`}
                onClick={() => nav("chinese-writing")}
              >
                <FitnessCenterIcon className="icon-sm" /> Practice
              </button>
            </div>
          )}

        </div>

        <div className="sidebar-footer">
          <button className="sidebar-home-btn" onClick={() => { onHome(); onClose(); }}>
            <HomeIcon className="icon-sm" /> Home / Reset
          </button>
        </div>

      </aside>
    </>
  );
}
